var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"d-flex flex-row gap-2 my-2 justify-center pb-2"},[_vm._t("default")],2),(!!_vm.error)?_c('v-alert',{staticClass:"mt-n3",attrs:{"dense":"","outlined":"","type":"error"}},[_vm._v(" "+_vm._s(_vm.error)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }